import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { LanguageLoader } from '../../assets/languages';
import { GetRelationshipAPI } from '../../services';
import { Link, useNavigate, useParams } from "react-router-dom";
import FormatValue from './FormatValues';
import { SubpanelSkeleton } from '../layouts/Skeleton';

const Subpanel = ({data}) =>
{
	const settings = useSelector(state => state.settings);
	const preferences = useSelector((state) => state.preferences);	
	const language = LanguageLoader(preferences.language);
	const [subpanelData, SetSubpanelData] = useState([]);
	const {module, id} = useParams();
	const [relatedField, subpanelModule] = data;
	const definition = settings.definitions.subpanels[subpanelModule];
	const [loading, SetLoading] = useState(true);
	const navigate = useNavigate();

	useEffect(() =>
	{
		SetLoading(true);
		GetData();
	// eslint-disable-next-line
	}, [module, id]);
	
	const GetData = async () =>
	{
		try {
			var selectedFields = ['id'];
			const FieldKeys = Object.keys(definition.fields);
			selectedFields.push(...FieldKeys);
			const relatedFields = Object.values(definition.fields)
				.filter(field => field.related_to)
				.map(field => field.related_to);
			selectedFields = Array.from(new Set([...selectedFields, ...relatedFields]));
			const data = {
				module : module,
				related_field : relatedField,
				selected_fields : selectedFields,
				id : id
			};
			const APIResponse = await GetRelationshipAPI(data);
			if(APIResponse)
			{
				SetSubpanelData(APIResponse);
				SetLoading(false);
			}
			else
			{
				SetSubpanelData([]);
				SetLoading(false);
			}
		} catch (error) { SetSubpanelData([]); }
	}

	if(!definition)
	{
		return null;
	}

	return (
		<>
		{loading ? <SubpanelSkeleton/> :
		<div className="wrapper">
			<div className='title flex justify-between w-full'>
				<h6>{definition.label[preferences.language] ? definition.label[preferences.language] : language.MODULES[definition.module.toUpperCase()]}</h6>
				<div className="me-3 cursor-pointer">
				{definition.fields && definition.access.create ?
					<i className="py-4 px-2 fa fa-plus fa-lg bg-primary text-white rounded-md" onClick={() => navigate('/edit/'+definition.module, {state:{subpanel: true, parent: {module: module, id: id}}})}></i>
				: null }
				</div>
			</div>
			<table>
				<thead>
					<tr>{Object.keys(definition).length ? Object.values(definition.fields).map((field) =>
					{
						return (field.list ? <th key={field.name}>{field.label[preferences.language]}</th> : null)
					}) : <th></th> }
					</tr>
				</thead>
				<tbody>
					{subpanelData.length && definition.access.view ? subpanelData.map((rowData, rowIndex) => <tr key={rowIndex}>
						{Object.values(definition.fields).map((field, cellIndex) =>
						{
							return (field.list ? <td key={cellIndex}><Link to={'/subpanel/'+definition.module+'/'+rowData.id}><FormatValue value={rowData[field.name]} vardef={field} format={true} related_to={(field['related_to'] ? rowData[field['related_to']] : null)}/></Link></td> : null)
						})}
						</tr>
					) : <tr><td colSpan="100%">{language.ERROR.NOTHING_TO_SHOW}</td></tr> }
				</tbody>
			</table>
		</div>
		}
		</>
	);
};

export default Subpanel;